// pages/Services.js
import React, { useEffect } from "react";
import Header from "../components/home/Header";

import TrustSection from "../components/contact/TrustSection";
import Footer from "../components/home/Footer";
import RequestQuote from "../components/home/RequestQuote";

function ContactPage() {

  const requestQuoteStyle = {
    bgColor: "white",
    color: "black",
    placeholderColor: "black",

    // for animated button 
    bgGradient:
      "linear-gradient(270deg, #F15424 0%, #F15A24 50%, #D72128 100%)",
    textColor: "linear-gradient(270deg, #F15424 0%, #F15A24 50%, #D72128 100%)",
    hoverBg: "#000",
    hoverText: "linear-gradient(270deg, #fff 0%, #fff 100%)",
    hoverArrow:
      "linear-gradient(270deg, #F15424 0%, #F15A24 50%, #D72128 100%)",
  };

  return (
    <div>
      <Header />
      <RequestQuote styles={requestQuoteStyle} />
      <TrustSection />
      <Footer />
    </div>
  );
}

export default ContactPage;
